import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { EnfermeiroService } from '../../enfermeiro.service';
import { Enfermeiro } from 'app/core/interfaces/enfermeiro.interface';
import { AlertsService } from 'app/shared/alerts.service';
import { Router } from '@angular/router';
import { ModalsService } from 'app/shared/modals.service';
import { AuthService } from 'app/core/auth/auth.service';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { Organizacao } from 'app/core/interfaces/organizacao.interface';

@Component({
  selector: 'app-enfermeiro-editar-perfil',
  templateUrl: './enfermeiro-editar-perfil.component.html',
  styleUrls: ['./enfermeiro-editar-perfil.component.scss']
})
export class EnfermeiroEditarPerfilComponent implements AfterViewInit {

  formulario: FormGroup;
  perfil: Enfermeiro = Enfermeiro.createEmpty();
  organizacao: Organizacao = Organizacao.createEmpty();

  form: FormGroup = new FormGroup({
    primeiro_nome: new FormControl('', [Validators.required]),
    sobrenome: new FormControl('', [Validators.required]),
    idade: new FormControl('', [Validators.required]),
    endereco: new FormControl('', [Validators.required]),
    cidade: new FormControl('', [Validators.required]),
    estado: new FormControl('', [Validators.required]),
    cpf: new FormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(11), Validators.pattern('^[0-9]*$')]),
    cbo: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(6), Validators.pattern('^[0-9]*$')]),
    cns: new FormControl('', [Validators.minLength(15), Validators.maxLength(15), Validators.pattern('^[0-9]*$')]),
    cns_tipo: new FormControl('medico', []),

    name_instagram: new FormControl(''),
    telefone: new FormControl('', [
      Validators.pattern('^[0-9]*$'),
      Validators.minLength(10),
      Validators.maxLength(11)
    ]),
    whatsapp: new FormControl('', [
      Validators.pattern('^[0-9]*$'),
      Validators.minLength(11),
      Validators.maxLength(11)
    ]),
    
    email: new FormControl('', [Validators.required, Validators.email])
  });


  maximo_cartoes = 0;
  cartoes_usados = 0;

  /** Formulário de atualizar senha */
  atualizarSenha: FormGroup = new FormGroup({
    senha_atual: new FormControl('', Validators.required),
    nova_senha: new FormControl('', Validators.required),
    confirmar_senha: new FormControl('', Validators.required),
  });

  senhas_nao_iguais = false;

  /** Formulário para atualizar o email */
  atualizarEmail: FormGroup = new FormGroup({
    novo_email: new FormControl('', Validators.required),
    confirmar_email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });

  email_nao_iguais = false;
  visiblePassword = false;

  loading = true;
  outras_opcoes = false;

  bloqueado_por_limite_de_cartoes = false;

  @ViewChild('imageUploader') image_uploader;

  constructor(
    private enfermeirosService: EnfermeiroService,
    private snackService: AlertsService,
    private router: Router,
    private modalService: ModalsService,
    private authService: AuthService,
    private _apigestacard: APIGestaCardService,
  ) { }

  /** Lyfe cicle hooks */

  ngAfterViewInit() {
    this.BuscarPerfilEnfermeiro();
  }

  setVisiblePassword(visiblePassword: boolean) {
    this.visiblePassword = visiblePassword;
  }

  /** Funções do componente */
  BuscarPerfilEnfermeiro() {
    this.enfermeirosService.GetUserData().subscribe((res: Enfermeiro) => {
      this.perfil = res;

      this.enfermeirosService.GetOrgData().subscribe((org) => {
        this.organizacao = org;
        this.AtualizarFormulario();

        this.enfermeirosService.TotalCartoesUsadosPeloEnfermeiro(this.perfil.id).then((result) => {
          
          if (result >= this.perfil.maximo_cartoes) this.bloqueado_por_limite_de_cartoes = true;

        });
      });
    });
  }

  AtualizarFormulario() {
    if (!this.perfil) return;

    this.form.patchValue(this.perfil);
        
    if (this.form.controls.cpf) this.form.controls.cpf.disable();
    if (this.form.controls.cns) this.form.controls.cns.disable();
    if (this.form.controls.cns_tipo) this.form.controls.cns_tipo.disable();

    this.loading = false;

    if (this.organizacao.instituicao_publica === 'S') return

    this.form.removeControl('cbo');
    this.form.removeControl('cns');
    this.form.removeControl('cns_tipo');
  }

  async SalvarAlteracoes() {

    if (this.form.valid) {

      const novo_obj_usuario = { ...this.perfil, ...this.form.getRawValue() };

      // Verificando se a imagem mudou 
      if (this.image_uploader.foto_mudou) {

        const imagem = this.image_uploader.imagePath;
        const image_to_upload = imagem[0];

        const url = await this._apigestacard.UploadImage(image_to_upload);

        novo_obj_usuario['url'] = url;

      }

      this.enfermeirosService.AtualizarPerfilEnfermeiro(novo_obj_usuario).then((res) => {

        this.snackService.SnackMessage('Perfil Atualizado com sucesso!');
        this.authService.AtualizarDadosDoUsuario(res.email, 'enfermeiro');
        this.router.navigate(['/enfermeiro']);
        
      }).catch((err) => {

        this.snackService.SnackMessage(err);

      });

    }

  }

  Voltar() {
    this.router.navigateByUrl('/enfermeiro');
  }

  AlterarSenha() {

    if (this.atualizarSenha.valid) {

      const senha_atual = this.atualizarSenha.controls.senha_atual.value;
      const nova_senha = this.atualizarSenha.controls.nova_senha.value;
      const confirmar_senha = this.atualizarSenha.controls.confirmar_senha.value;

      // Verificando as senhas
      if (confirmar_senha != nova_senha) {

        this.senhas_nao_iguais = true;

      } else {

        this.senhas_nao_iguais = false;
        this.authService.UpdatePassword(this.perfil.email, senha_atual, nova_senha).then(() => {
            
          this.snackService.SnackMessage('Senha alterada com sucesso!');
          
        }).catch((err) => {

          this.snackService.SnackMessage(`Erro ao atualizar senha: ${JSON.stringify(err)}`);

        });

      }

    }

  }

  AlterarEmail() {

    if (this.atualizarEmail.valid) {

      const novo_email = this.atualizarEmail.controls.novo_email.value;
      const confirmar_email = this.atualizarEmail.controls.confirmar_email.value;
      const password = this.atualizarEmail.controls.password.value;

      if (novo_email != confirmar_email) {

        this.email_nao_iguais = true;

      } else {

        this.email_nao_iguais = false;
        this.authService.UpdateEmail(novo_email, password).then(() => {

          this.snackService.SnackMessage('E-mail atualizado com sucesso!, Faça o login novamente');

          setTimeout(() => this.authService.Logout(), 1000);

        }).catch((err) => {

          this.snackService.SnackMessage(err);

        });

      }

    }

  }

  DeletarPerfil() {
    this.modalService.AbrirModalDeConfirmacao('Deseja Excluir perfil?', 'Todos os seus dados serão apagados, e não será possível recuperá-los, deseja continuar?').subscribe((res: boolean) => {
      if (res) {
        
      }
    });
  }

  get primeiro_nome() { return this.form.get('primeiro_nome'); }
  get sobrenome() { return this.form.get('sobrenome'); }
  get idade() { return this.form.get('idade'); }
  get endereco() { return this.form.get('endereco'); }
  get cidade() { return this.form.get('cidade'); }
  get estado() { return this.form.get('estado'); }
  get telefone() { return this.form.get('telefone'); }
  get whatsapp() { return this.form.get('whatsapp'); }
  get name_instagram() { return this.form.get('name_instagram'); }
  get cbo() { return this.form.get('cbo'); }
  get cpf() { return this.form.get('cpf'); }
  get cns() { return this.form.get('cns'); }
  get cns_tipo() { return this.form.get('cns_tipo'); }
  get email() { return this.form.get('email'); }
}
